import {StyleSheet} from 'react-native';
import {colors} from './src/assets/styles/colors';

const MainStyle = StyleSheet.create({
  border: {borderStyle: 'solid', borderColor: 'red', borderWidth: 1},
  bc_gray: {backgroundColor: colors.gray},
  bc_darkblue: {backgroundColor: colors.bottomTabBg},
  bc_popupDropBg: {backgroundColor: colors.popupDropBg},
  bc_greenText: {backgroundColor: colors.greenText},
  bc_green: {backgroundColor: colors.green},
  bc_modalBg: {backgroundColor: colors.modalBg},
  bg_contest: {backgroundColor: colors.bg_contest},
  bg_main: {backgroundColor: colors.mainBackground},
  bg_new_bg: {backgroundColor: colors.new_bg},
  bg_warningText: {backgroundColor: colors.warningText},
  bg_white: {backgroundColor: 'white'},
  bg_settings: {backgroundColor: colors.settings_bg},
  bg_new_input_color: {backgroundColor: colors.new_input_color},
  bg_deposit: {backgroundColor: colors.deposit_bg},
  bg_filter_chip: {backgroundColor: colors.filter_chip_bg},
  bg_filter_modal: {backgroundColor: colors.filter_modal_bg},
  bg_black: {backgroundColor: colors.mainBg},
  bg_loading_login: {backgroundColor: colors.loading_login},
  bg_newGreen: {backgroundColor: colors.newGreenText},
  bg_darkText: {backgroundColor: colors.darkText},
  bg_darkOverlay: {backgroundColor: colors.darkOverlay},
  bg_transparent: {backgroundColor: 'transparent'},
  bg_newDarkBlue: {backgroundColor: colors.newDarkBlue},
  max_w_59: {maxWidth: 59},
  max_w_260: {maxWidth: 260},
  max_w_312: {maxWidth: 312},
  max_w_323: {maxWidth: 323},
  max_w_332: {maxWidth: 332},
  max_w_340: {maxWidth: 340},
  max_w_387: {maxWidth: 387},
  max_w_430: {maxWidth: 430},
  max_w_570: {maxWidth: 570},
  max_w_690: {maxWidth: 690},
  max_w_1040: {maxWidth: 1040},
  max_w_1100: {maxWidth: 1100},
  max_w_1120: {maxWidth: 1120},
  max_w_1205: {maxWidth: 1205},
  full_w: {width: '100%'},
  full_h: {height: '100%'},
  p_b_10: {paddingBottom: 10},
  p_b_15: {paddingBottom: 15},
  p_b_29: {paddingBottom: 29},
  p_b_41: {paddingBottom: 41},
  p_b_67: {paddingBottom: 67},
  b_r_2: {borderRadius: 2},
  b_r_4: {borderRadius: 4},
  b_r_8: {borderRadius: 8},
  b_r_12: {borderRadius: 12},
  b_r_14: {borderRadius: 14},
  b_r_16: {borderRadius: 16},
  b_r_20: {borderRadius: 20},
  b_r_40: {borderRadius: 40},
  b_r_70: {borderRadius: 70},
  b_r_200: {borderRadius: 200},
  c_light_blue: {color: colors.popupBorder},
  c_white: {color: colors.whiteText},
  c_mainBackground: {color: colors.mainBackground},
  c_yellow: {color: colors.darkYellow},
  c_black: {color: colors.mainBg},
  c_gray: {color: '#989898'},
  c_warn: {color: colors.newDangerText},
  c_lightblue: {color: colors.lightBlue},
  c_title_blue: {color: colors.blueText},
  c_popupDangerPrimary: {color: colors.popupDangerPrimary},
  c_green: {color: '#43D120'},
  c_green_text: {color: colors.greenText},
  c_new_green_text: {color: colors.newGreenText},
  m_b_0: {marginBottom: 0},
  m_b_1: {marginBottom: 1},
  m_b_2: {marginBottom: 2},
  m_b_3: {marginBottom: 3},
  m_b_4: {marginBottom: 4},
  m_b_5: {marginBottom: 5},
  m_b_6: {marginBottom: 6},
  m_b_8: {marginBottom: 8},
  m_b_9: {marginBottom: 9},
  m_b_10: {marginBottom: 10},
  m_b_11: {marginBottom: 11},
  m_b_12: {marginBottom: 12},
  m_b_13: {marginBottom: 13},
  m_b_14: {marginBottom: 14},
  m_b_15: {marginBottom: 15},
  m_b_16: {marginBottom: 16},
  m_b_17: {marginBottom: 17},
  m_b_18: {marginBottom: 18},
  m_b_19: {marginBottom: 19},
  m_b_20: {marginBottom: 20},
  m_b_21: {marginBottom: 21},
  m_b_22: {marginBottom: 22},
  m_b_23: {marginBottom: 23},
  m_b_24: {marginBottom: 24},
  m_b_25: {marginBottom: 25},
  m_b_26: {marginBottom: 26},
  m_b_28: {marginBottom: 28},
  m_b_29: {marginBottom: 29},
  m_b_30: {marginBottom: 30},
  m_b_31: {marginBottom: 31},
  m_b_32: {marginBottom: 32},
  m_b_34: {marginBottom: 34},
  m_b_37: {marginBottom: 37},
  m_b_38: {marginBottom: 38},
  m_b_40: {marginBottom: 40},
  m_b_42: {marginBottom: 42},
  m_b_45: {marginBottom: 45},
  m_b_47: {marginBottom: 47},
  m_b_60: {marginBottom: 60},
  m_b_62: {marginBottom: 62},
  m_b_64: {marginBottom: 64},
  m_b_70: {marginBottom: 70},
  m_b_80: {marginBottom: 80},
  m_b_101: {marginBottom: 101},
  m_b_112: {marginBottom: 112},
  m_b_125: {marginBottom: 125},
  m_b_158: {marginBottom: 158},
  flex: {display: 'flex'},
  row: {display: 'flex', flexDirection: 'row'},
  column: {display: 'flex', flexDirection: 'column'},
  a_i_c: {alignItems: 'center'},
  a_i_e: {alignItems: 'flex-end'},
  o_0: {opacity: 0},
  o_05: {opacity: 0.5},
  o_06: {opacity: 0.6},
  w_6: {width: 6},
  w_8: {width: 8},
  w_10: {width: 10},
  w_12: {width: 12},
  w_13: {width: 13},
  w_14: {width: 14},
  w_16: {width: 16},
  w_19: {width: 19},
  w_20: {width: 20},
  w_21: {width: 21},
  w_24: {width: 24},
  w_28: {width: 28},
  w_30: {width: 30},
  w_32: {width: 32},
  w_36: {width: 36},
  w_40: {width: 40},
  w_42: {width: 42},
  w_44: {width: 44},
  w_45: {width: 45},
  w_48: {width: 48},
  w_53: {width: 53},
  w_60: {width: 60},
  w_64: {width: 64},
  w_80: {width: 80},
  w_100: {width: 100},
  w_107: {width: 107},
  w_116: {width: 116},
  w_118: {width: 118},
  w_120: {width: 120},
  w_129: {width: 129},
  w_130: {width: 130},
  w_144: {width: 144},
  w_160: {width: 160},
  w_164: {width: 164},
  w_168: {width: 168},
  w_170: {width: 170},
  w_176: {width: 176},
  w_184: {width: 184},
  w_190: {width: 190},
  w_194: {width: 194},
  w_220: {width: 220},
  w_224: {width: 224},
  w_225: {width: 225},
  w_233: {width: 233},
  w_240: {width: 240},
  w_255: {width: 255},
  w_267: {width: 267},
  w_271: {width: 271},
  w_286: {width: 286},
  w_300: {width: 300},
  w_312: {width: 312},
  w_330: {width: 330},
  w_338: {width: 338},
  w_350: {width: 350},
  w_360: {width: 360},
  w_370: {width: 370},
  w_389: {width: 389},
  w_480: {width: 480},
  w_640: {width: 640},
  h_1: {height: 1},
  h_4: {height: 4},
  h_6: {height: 6},
  h_9: {height: 9},
  h_10: {height: 10},
  h_12: {height: 12},
  h_13: {height: 13},
  h_14: {height: 14},
  h_15: {height: 15},
  h_16: {height: 16},
  h_18: {height: 18},
  h_19: {height: 19},
  h_20: {height: 20},
  h_21: {height: 21},
  h_22: {height: 22},
  h_24: {height: 24},
  h_26: {height: 26},
  h_28: {height: 28},
  h_30: {height: 30},
  h_32: {height: 32},
  h_37: {height: 37},
  h_40: {height: 40},
  h_41: {height: 41},
  h_46: {height: 46},
  h_48: {height: 48},
  h_51: {height: 51},
  h_55: {height: 55},
  h_59: {height: 59},
  h_60: {height: 60},
  h_63: {height: 63},
  h_64: {height: 64},
  h_66: {height: 66},
  h_72: {height: 72},
  h_80: {height: 80},
  h_90: {height: 90},
  h_100: {height: 100},
  h_118: {height: 118},
  h_150: {height: 150},
  h_159: {height: 159},
  h_160: {height: 160},
  h_176: {height: 176},
  h_234: {height: 234},
  h_240: {height: 240},
  h_253: {height: 253},
  h_271: {height: 271},
  h_300: {height: 300},
  h_368: {height: 368},
  h_493: {height: 493},
  m_y_6: {marginVertical: 6},
  m_y_20: {marginVertical: 20},
  t_a_c: {textAlign: 'center'},
  t_a_l: {textAlign: 'left'},
  t_a_r: {textAlign: 'right'},
  f_s_10: {fontSize: 10},
  f_s_12: {fontSize: 12},
  f_s_14: {fontSize: 14},
  f_s_15: {fontSize: 15},
  f_s_16: {fontSize: 16},
  f_s_17: {fontSize: 17},
  f_s_18: {fontSize: 18},
  f_s_20: {fontSize: 20},
  f_s_21: {fontSize: 21},
  f_s_22: {fontSize: 22},
  f_s_23: {fontSize: 23},
  f_s_24: {fontSize: 24},
  f_s_25: {fontSize: 25},
  f_s_26: {fontSize: 26},
  f_s_28: {fontSize: 28},
  f_s_30: {fontSize: 30},
  f_s_32: {fontSize: 32},
  f_s_36: {fontSize: 36},
  f_s_40: {fontSize: 40},
  f_s_48: {fontSize: 48},
  f_s_52: {fontSize: 52},
  f_s_56: {fontSize: 56},
  f_s_60: {fontSize: 60},
  m_t__32: {marginTop: -32},
  m_t_6: {marginTop: 6},
  m_t_7: {marginTop: 7},
  m_t_10: {marginTop: 10},
  m_t_13: {marginTop: 13},
  m_t_17: {marginTop: 17},
  m_t_19: {marginTop: 19},
  m_t_20: {marginTop: 20},
  m_t_28: {marginTop: 28},
  m_t_34: {marginTop: 34},
  m_t_50: {marginTop: 50},
  m_t_114: {marginTop: 114},
  j_c_c: {justifyContent: 'center'},
  j_c_s_between: {justifyContent: 'space-between'},
  j_c_s_around: {justifyContent: 'space-around'},
  flex1: {flex: 1},
  p_10: {padding: 10},
  o_hidden: {overflow: 'hidden'},
  m_l__32: {marginLeft: -32},
  m_l__10: {marginLeft: -10},
  m_l_2: {marginLeft: 2},
  m_l_4: {marginLeft: 4},
  m_l_6: {marginLeft: 6},
  m_l_8: {marginLeft: 8},
  m_l_9: {marginLeft: 9},
  m_l_10: {marginLeft: 10},
  m_l_12: {marginLeft: 12},
  m_l_15: {marginLeft: 15},
  m_l_20: {marginLeft: 20},
  m_l_21: {marginLeft: 21},
  m_l_22: {marginLeft: 22},
  m_l_24: {marginLeft: 24},
  m_l_28: {marginLeft: 28},
  m_l_32: {marginLeft: 32},
  m_l_37: {marginLeft: 37},
  m_l_52: {marginLeft: 52},
  m_l_77: {marginLeft: 77},
  b_b_w_1: {borderBottomWidth: 1},
  b_b_w_3: {borderBottomWidth: 3},
  b_c_transparent: {borderColor: 'transparent'},
  b_c_black: {borderColor: 'black'},
  b_c_gray: {borderColor: '#494A4C'},
  b_c_blue: {borderColor: colors.blue},
  b_c_white: {borderColor: colors.whiteText},
  b_c_warn: {borderColor: colors.newDangerText},
  b_c_yellow: {borderColor: colors.darkYellow},
  b_c_blueText: {borderColor: colors.blueText},
  b_c_popupBorder: {borderColor: colors.popupBorder},
  b_c_settings_border: {borderColor: colors.settings_border},
  b_c_darkText: {borderColor: colors.darkText},
  b_c_newGreen: {borderColor: colors.newGreenText},
  b_c_filter_chip_bg: {borderColor: colors.filter_chip_bg},
  p_x_8: {paddingHorizontal: 8},
  p_x_9: {paddingHorizontal: 9},
  p_x_10: {paddingHorizontal: 10},
  p_x_13: {paddingHorizontal: 13},
  p_x_15: {paddingHorizontal: 15},
  p_x_16: {paddingHorizontal: 16},
  p_x_20: {paddingHorizontal: 20},
  p_x_24: {paddingHorizontal: 24},
  p_x_26: {paddingHorizontal: 26},
  p_x_27: {paddingHorizontal: 27},
  p_x_30: {paddingHorizontal: 30},
  p_x_32: {paddingHorizontal: 32},
  p_x_36: {paddingHorizontal: 36},
  p_x_80: {paddingHorizontal: 80},
  m_r__10: {marginRight: -10},
  m_r_2: {marginRight: 2},
  m_r_7: {marginRight: 7},
  m_r_9: {marginRight: 9},
  m_r_10: {marginRight: 10},
  m_r_15: {marginRight: 15},
  m_r_24: {marginRight: 24},
  relative: {position: 'relative'},
  p_l_10: {paddingLeft: 10},
  p_l_16: {paddingLeft: 16},
  p_r_18: {paddingRight: 18},
  p_r_20: {paddingRight: 20},
  p_r_34: {paddingRight: 34},
  f_w_400: {fontWeight: '400'},
  f_w_600: {fontWeight: '600'},
  f_w_700: {fontWeight: '700'},
  f_w_800: {fontWeight: '800'},
  f_w_900: {fontWeight: '900'},
  m_x_auto: {marginHorizontal: 'auto'},
  m_x_3: {marginHorizontal: 3},
  m_x_6: {marginHorizontal: 6},
  m_x_7: {marginHorizontal: 7},
  m_x_8: {marginHorizontal: 8},
  m_x_10: {marginHorizontal: 10},
  m_x_15: {marginHorizontal: 15},
  m_x_16: {marginHorizontal: 16},
  m_x_19: {marginHorizontal: 19},
  m_x_20: {marginHorizontal: 20},
  m_x_23: {marginHorizontal: 23},
  m_x_40: {marginHorizontal: 40},
  min_h_32: {minHeight: 32},
  min_h_90: {minHeight: 90},
  min_h_164: {minHeight: 164},
  min_h_452: {minHeight: 452},
  min_h_510: {minHeight: 510},
  min_h_full: {minHeight: '100%'},
  p_y_12: {paddingVertical: 12},
  p_y_15: {paddingVertical: 15},
  p_y_19: {paddingVertical: 19},
  p_y_23: {paddingVertical: 23},
  p_y_70: {paddingVertical: 70},
  r__28: {right: -28},
  r__22: {right: -22},
  r__17: {right: -17},
  r__12: {right: -12},
  r__1: {right: -1},
  r_0: {right: 0},
  r_10: {right: 10},
  r_15: {right: 15},
  r_20: {right: 20},
  r_56: {right: 56},
  l_50_percent: {left: '50%'},
  l__75: {left: -75},
  l__56: {left: -56},
  l__2: {left: -2},
  l__1: {left: -1},
  l_0: {left: 0},
  l_5: {left: 5},
  l_15: {left: 15},
  l_18: {left: 18},
  absolute: {position: 'absolute'},
  b_0: {bottom: 0},
  b_1: {bottom: 1},
  b_47: {bottom: 47},
  l_h_3_5: {lineHeight: 3.5},
  l_h_12: {lineHeight: 12},
  l_h_14: {lineHeight: 14},
  l_h_16: {lineHeight: 16},
  l_h_18: {lineHeight: 18},
  l_h_19: {lineHeight: 19},
  l_h_20: {lineHeight: 20},
  l_h_22: {lineHeight: 22},
  l_h_23: {lineHeight: 23},
  l_h_24: {lineHeight: 24},
  l_h_26: {lineHeight: 26},
  l_h_27: {lineHeight: 27},
  l_h_30: {lineHeight: 30},
  l_h_32: {lineHeight: 32},
  l_h_33: {lineHeight: 33},
  l_h_35: {lineHeight: 35},
  l_h_36: {lineHeight: 36},
  l_h_40: {lineHeight: 40},
  l_h_47: {lineHeight: 47},
  l_h_48: {lineHeight: 48},
  l_h_50: {lineHeight: 50},
  l_h_55: {lineHeight: 55},
  l_h_78: {lineHeight: 78},
  l_h_80: {lineHeight: 80},
  b_w_0: {borderWidth: 0},
  b_w_1: {borderWidth: 1},
  b_w_3: {borderWidth: 3},
  p_t_10: {paddingTop: 10},
  p_t_13: {paddingTop: 13},
  p_t_17: {paddingTop: 17},
  p_t_18: {paddingTop: 18},
  p_t_19: {paddingTop: 19},
  p_t_20: {paddingTop: 20},
  p_t_22: {paddingTop: 22},
  p_t_23: {paddingTop: 23},
  p_t_25: {paddingTop: 25},
  p_t_28: {paddingTop: 28},
  p_t_30: {paddingTop: 30},
  p_t_46: {paddingTop: 46},
  p_t_60: {paddingTop: 60},
  rm_center: {resizeMode: 'center'},
  rm_contain: {resizeMode: 'contain'},
  rm_stretch: {resizeMode: 'stretch'},
  rm_cover: {resizeMode: 'cover'},
  italic: {fontStyle: 'italic'},
  t_50_percent: {top: '50%'},
  t__99: {top: -99},
  t__81: {top: -81},
  t__70: {top: -70},
  t__28: {top: -28},
  t__4: {top: -4},
  t_0: {top: 0},
  t_9: {top: 9},
  t_30: {top: 30},
  t_35: {top: 35},
  b_t_l_r_0: {borderTopLeftRadius: 0},
  b_t_l_r_14: {borderTopLeftRadius: 14},
  b_t_l_r_28: {borderTopLeftRadius: 28},
  b_t_r_r_0: {borderTopRightRadius: 0},
  b_t_r_r_14: {borderTopRightRadius: 14},
  b_b_l_r_0: {borderBottomLeftRadius: 0},
  b_b_l_r_14: {borderBottomLeftRadius: 14},
  b_b_l_r_28: {borderBottomLeftRadius: 28},
  b_b_r_r_0: {borderBottomRightRadius: 0},
  b_b_r_r_14: {borderBottomRightRadius: 14},
  b_t_w_3: {borderTopWidth: 3},
  b_l_w_0: {borderLeftWidth: 0},
  z_i__1: {zIndex: -1},
  z_i_2: {zIndex: 2},
  t_t_u: {textTransform: 'uppercase'},
  fix_gradient_and_modal_error_in_landscape: {borderWidth: 0.1, borderColor: 'black'},
  b_r_w_0: {borderRightWidth: 0},
  Barlow400: {fontFamily: 'Barlow-Regular'},
  Barlow500: {fontFamily: 'Barlow-Medium'},
  Barlow600: {fontFamily: 'Barlow-SemiBold'},
  Barlow700: {fontFamily: 'Barlow-Bold'},
  Alternox400: {fontFamily: 'Alternox-Regular'},
  Alternox600: {fontFamily: 'Alternox-SemiBold'},
  Alternox700: {fontFamily: 'Alternox-Bold'},
  DavisSans400: {fontFamily: 'DavisSans-Regular'},
  DavisSans500: {fontFamily: 'DavisSans-Medium'},
  Stratos700Italic: {fontFamily: 'StratosBoldItalic'},
  t_d_l_u: {textDecorationLine: 'underline'},
  textShadow: {textShadowOffset: {width: 0, height: 2}, textShadowRadius: 2, textShadowColor: 'rgba(0, 0, 0, 0.50)'},
  gradientShadow: {
    shadowColor: '#000', shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4, elevation: 4
  },
  l_s_5: {letterSpacing: 5},
  textShadow10: {textShadowColor: '#000', textShadowOffset: {width: 0, height: 0}, textShadowRadius: 10},
  textShadow3: {textShadowColor: 'rgba(0, 0, 0, 0.65)', textShadowOffset: {width: 0, height: 3}, textShadowRadius: 3}
});

export default MainStyle;
